import { get } from "lodash";
import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
import { CompGridFormCodes } from "components/Homeowner/CaseForms/ComparableGrid/CompGridFormCodes";
import { garageFieldsByFormCode } from "components/Homeowner/CaseForms/ComparableGrid/Misc";

const isRequired = (req, comp, dir, compGridFormCode, table, key) => {
  if (typeof (req) === "function") return req(comp, dir, compGridFormCode, table, key);
  else return req;
};

const hasValue = (tab, key, dir) => {
  if (key === sections.PROXIMITY_TO_SUBJECT) {
    return !!tab[key][dir].value.displayValue;
  }
  if (key === sections.PRIMARY_PHOTO) {
    return tab[key][dir].value; 
  }
  let val = get(tab[key], [dir, "value"]);
  return !!val || val === 0;  //0 is a valid value
};

const getHeadAndBodyKeys = (table, groupValue) => {
  let dto = {
    head: [],
    body: []
  };
  const value = (key) => get(table[0][key], ["row", "value"]);
  const type = (key) => get(table[0][key], ["row", "type"]);
  for (const key in table[0]) {
    if (value(key) === groupValue) {
      if (type(key) === "head") {
        dto.head = [...dto.head, key];
      } else if (type(key) === "body") {
        dto.body = [...dto.body, key];
      }
    }
  }
  return dto;
};

export const validateTable = (table, compGridFormCode) => {
  let errorKeys = new Set();
  table.forEach(tab => {
    Object.keys(tab).forEach(key => {
      if ((isRequired(get(tab[key], ["left", "required"]), tab, "left", compGridFormCode, table, key) && !hasValue(tab, key, "left")) ||
        (isRequired(get(tab[key], ["right", "required"]), tab, "right", compGridFormCode, table, key) && !hasValue(tab, key, "right"))) {
        errorKeys.add(key);
        if (get(tab[key], ["row", "type"]) === "body") {
          // find head and add that as well
          let groupValue = get(tab[key], ["row", "value"]);
          let keys = getHeadAndBodyKeys(table, groupValue);
          keys.head.forEach(key => errorKeys.add(key));
        }
      }
    });
  });
  return [...errorKeys];
};

export const validateField = (table, subTableKey, errorKeys, compGridFormCode) => {
  const validate = (table, subTableKey) => {
    if(subTableKey === sections.DRIVEWAY) 
    {
      return true;
    }
    for (let i = 0; i < table.length; i++) {
      if ((isRequired(get(table[i][subTableKey], ["left", "required"]), table[i], "left", compGridFormCode, table, subTableKey) && !hasValue(table[i], subTableKey, "left")) ||
        (isRequired(get(table[i][subTableKey], ["right", "required"]), table[i], "right", compGridFormCode, table, subTableKey) && !hasValue(table[i], subTableKey, "right"))) {
        return false;
      }
    }
    return true;
  };
  let newErrorKeys = [...errorKeys];
  let groupValue = get(table[0][subTableKey], ["row", "value"]);
  let keys = getHeadAndBodyKeys(table, groupValue);

  let allFieldsValid = true;
  for (let key of [...keys.head, ...keys.body]) {
    if (validate(table, key)) newErrorKeys = newErrorKeys.filter((errKey) => errKey !== key);
    else {
      allFieldsValid = false;
      newErrorKeys = [...newErrorKeys, key];
    }
  }
  if (!allFieldsValid) {
    // if all fields did not validate, add the head keys back
    newErrorKeys = [...newErrorKeys, ...keys.head];
  }
  return newErrorKeys;
};

export const drivewayRequired = (comp, dir) => {
  let garageFields = garageFieldsByFormCode(comp);
  return !comp[garageFields.garageCarport][dir].value &&
  (!comp[garageFields.carStorage1][dir].value || comp[garageFields.carStorage1][dir].value === "None");
};

export const numOfCarsRequired = (comp, dir) => {
  let garageFields = garageFieldsByFormCode(comp);
  let drivewayReq = drivewayRequired(comp, dir) && !comp[garageFields.driveway][dir].value;
  return !comp[garageFields.garageCarport][dir].value &&
    (drivewayReq || comp[garageFields.driveway][dir].value === "yes");
};

export const carStorage1Required = (comp, dir) => {
  let garageFields = garageFieldsByFormCode(comp);
  return !comp[garageFields.garageCarport][dir].value &&
  comp[garageFields.driveway][dir].value !== "yes";
};

export const attachmentType1Required = (comp, dir) => {
  let garageFields = garageFieldsByFormCode(comp);
  let carStorageRequired = carStorage1Required(comp, dir) && !comp[garageFields.carStorage1][dir].value;
  return !comp[garageFields.garageCarport][dir].value &&
    (carStorageRequired || comp[garageFields.carStorage1][dir].value === "Garage");
};

export const numOfCars1Required = (comp, dir) => {
  let garageFields = garageFieldsByFormCode(comp);
  let carStorageRequired = carStorage1Required(comp, dir) && !comp[garageFields.carStorage1][dir].value;
  return !comp[garageFields.garageCarport][dir].value &&
    (carStorageRequired || ["Garage", "Carport"].includes(comp[garageFields.carStorage1][dir].value));
};

export const basementExitTypeRequired = (comp, dir, compGridFormCode) =>
(compGridFormCode === CompGridFormCodes.COLLATERAL_APPRAISAL_COMPARABLES 
  && 
  !(comp[sections.BELOW_GRADE_TOT_SF][dir].value === 0 || comp[sections.BELOW_GRADE_TOT_SF][dir].value === "0"))
||
(compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE 
  && 
  !(comp[sections.BELOW_GRADE_TOT_SF_BBT][dir].value === 0 || comp[sections.BELOW_GRADE_TOT_SF_BBT][dir].value === "0"));

export const belowGradeFinSFRequired = (comp, dir, compGridFormCode) => {
  if ((compGridFormCode === CompGridFormCodes.COLLATERAL_APPRAISAL_COMPARABLES && (comp[sections.BELOW_GRADE_TOT_SF][dir].value === 0 || comp[sections.BELOW_GRADE_TOT_SF][dir].value === "0"))
  || (compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE && (comp[sections.BELOW_GRADE_TOT_SF_BBT][dir].value === 0 || comp[sections.BELOW_GRADE_TOT_SF_BBT][dir].value === "0"))) {
    return false;
  }
  return true;
};

export const saleDateBBTAdjustmentRequired = (comp, dir, compGridFormCode) => 
  compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE && comp[sections.SALE_DATE_BBT]["left"].value;

// eslint-disable-next-line no-unused-vars
export const saleDateRequired = (comp, dir) => comp[sections.COMPARABLE_TYPE][dir].value === "sold";

export const otherBBTAdjustmentRequired = (comp, dir, compGridFormCode) => 
  compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE && comp[sections.OTHER_BBT]["left"].value;

export const financingTypeRequired = saleDateRequired;
export const contractDateRequired = saleDateRequired;
export const salePriceRequired = saleDateRequired;
export const statusTypeRequired = saleDateRequired;
export const saleOrFinancingRequired = saleDateRequired;
export const saleRequired = saleDateRequired;
export const concessionAmountRequired = saleDateRequired;

export const locationType1OtherRequired = (comp, dir) => comp[sections.LOCATION_TYPE][dir].value === "Other";
export const locationType2OtherRequired = (comp, dir) => comp[sections.LOCATION_TYPE_2][dir].value === "Other";

export const adjustmentRequired = (comp, dir, compGridFormCode, table, key) => 
  !([CompGridFormCodes.FNMA_APPRAISAL_COMPARABLE, CompGridFormCodes.REOMIT_APPRAISAL_COMPARABLES].includes(compGridFormCode) && comp[sections.COMPARABLE_TYPE]["left"].value === "list") 
  && hasValue(table[0], key, "right") 
  && hasValue(comp, key, "left") 
  && table[0][key]["right"].value != comp[key]["left"].value;